/* ============================================================
   CC- Küchenvorschau-Funnel — Upload-Seite Logik
   Erstellt von Claude Code (cc-)
   - Foto: Datei/Kamera + Vorschau + Drag&Drop + entfernen
   - Motiv-Picker: Drawer von rechts, Kachel-Auswahl, Suche
   - E-Mail aus URL (?email=) vorausgefüllt
   - Absenden: Foto -> Upload-Endpoint (POST), dann Danke-Seite ?motiv=
     (Endpoint leer = Demo, leitet ohne echten Upload weiter)
   ============================================================ */
(function () {
  function ccT(k, d) { var m = window.CC_I18N || {}; return m[k] ? m[k] : d; }
  var root = document.querySelector('.cc-up');
  if (!root) return;
  var uploadEndpoint = root.getAttribute('data-cc-upload-endpoint') || '';
  var dankeUrl = root.getAttribute('data-cc-danke-url') || '/pages/danke';
  var state = { file: null, previewUrl: null, motif: null, motifImg: null };

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return root.querySelectorAll(sel); };

  // Zentrales Klick-Tracking: GTM dataLayer + Meta Pixel (Custom Event)
  function ccTrack(event, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: event }, data || {})); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', event, data || {}); } catch (e) {}
  }

  // ---------- A/B-Test „E-Mail erst nach dem Foto" (29.09.2026) ----------
  // Zuteilung macht die Landing, das Inline-Skript der Section liest sie (window.CC_AB).
  // Variante B: E-Mail als Karte 3 erst nach Foto + Motiv, „Kein Foto zur Hand?" nimmt die
  // Adresse fuer den Link auf. Klaviyo-Eintrag und Meta-Lead passieren dann HIER statt auf
  // der Landing. tag a|b zaehlt, ta|tb = interner Test.
  var AB = window.CC_AB || { tag: '', modusB: false, src: '' };
  var abEndpoint = uploadEndpoint ? uploadEndpoint.replace(/\/preview\/?$/, '/ab') : '';
  function abMelden(schritt) {
    if ((AB.tag !== 'a' && AB.tag !== 'b') || !abEndpoint || !navigator.sendBeacon) return;
    try { navigator.sendBeacon(abEndpoint, new Blob([JSON.stringify({ v: AB.tag, s: schritt, src: AB.src || '' })], { type: 'text/plain' })); } catch (e) {}
  }
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || '').trim()); }
  // Gleicher Aufruf wie auf der Landing (cc-funnel-landingpage.js), dort erklaert.
  function klaviyoSubscribe(email) {
    var companyId = root.getAttribute('data-klaviyo-company') || '';
    var listId = root.getAttribute('data-klaviyo-list') || '';
    var source = (root.getAttribute('data-klaviyo-source') || 'Küchenvorschau-Funnel') +
      ' · Test B' + (AB.tag === 'tb' ? ' intern' : '');
    if (!companyId || !listId) return Promise.reject(new Error('klaviyo-config-missing'));
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      keepalive: true,
      headers: { 'revision': '2024-10-15', 'content-type': 'application/json' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source,
        profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { list: { data: { type: 'list', id: listId } } } } })
    }).then(function (res) {
      if (!res.ok && res.status !== 202) throw new Error('klaviyo-http-' + res.status);
      return res;
    });
  }
  function klaviyoIdentify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email });
      else { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['identify', { $email: email }]); }
    } catch (e) {}
  }
  // Lead fuer Meta: derselbe dataLayer-Name wie auf der Landing, der GTM-Trigger haengt daran.
  function leadMelden(email, schritt) {
    ccTrack('cc_lp_email_submit', { funnel_step: schritt, cc_ab: AB.tag });
    klaviyoIdentify(email);
    try { sessionStorage.setItem('cc_funnel_email', email); } catch (e) {}
    abMelden(schritt === 'upload_nofoto' ? 'nofoto' : 'email');
    return klaviyoSubscribe(email);
  }

  // ---------- Weiche: „Foto jetzt hochladen" / „Erstmal umschauen" ----------
  var choice = $('[data-cc-choice]');
  var flow = $('[data-cc-flow]');
  var choiceUpload = $('[data-cc-choice-upload]');
  var choiceBrowse = $('[data-cc-choice-browse]');
  if (choiceUpload) {
    choiceUpload.addEventListener('click', function () {
      ccTrack('cc_up_choice_upload', { funnel_step: 'upload_choice' });
      if (choice) choice.classList.add('cc-up-hidden');
      if (flow) {
        flow.classList.remove('cc-up-hidden');
        try { flow.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }
    });
  }
  if (choiceBrowse) {
    // Link folgt automatisch (href="…kuechenrueckwaende") — Event synchron davor feuern
    choiceBrowse.addEventListener('click', function () {
      ccTrack('cc_up_choice_browse', { funnel_step: 'upload_choice' });
    });
  }

  // Variante B: „Kein Foto zur Hand?" -> E-Mail fuer den Upload-Link
  var nofotoCard = $('[data-cc-choice-nofoto]');
  var nofoto = $('[data-cc-nofoto]');
  if (nofotoCard && nofoto) {
    var nfInput = $('[data-cc-nofoto-email]');
    var nfErr = $('[data-cc-nofoto-err]');
    var nfSend = $('[data-cc-nofoto-send]');
    var nfBack = $('[data-cc-nofoto-back]');
    var nfForm = $('[data-cc-nofoto-form]');
    var nfOk = $('[data-cc-nofoto-ok]');
    var nfFehler = function (msg) {
      if (!nfErr) return;
      nfErr.textContent = msg || '';
      nfErr.classList.toggle('cc-up-hidden', !msg);
    };
    nofotoCard.addEventListener('click', function () {
      ccTrack('cc_up_choice_nofoto', { funnel_step: 'upload_choice', cc_ab: AB.tag });
      if (choice) choice.classList.add('cc-up-hidden');
      nofoto.classList.remove('cc-up-hidden');
      try { nofoto.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      if (nfInput) { try { nfInput.focus(); } catch (e) {} }
    });
    if (nfInput) nfInput.addEventListener('input', function () { nfFehler(''); });
    if (nfBack) nfBack.addEventListener('click', function () {
      nofoto.classList.add('cc-up-hidden');
      if (flow) {
        flow.classList.remove('cc-up-hidden');
        try { flow.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }
    });
    if (nfSend) nfSend.addEventListener('click', function () {
      var em = nfInput ? nfInput.value.trim() : '';
      var d = submitHint ? submitHint.dataset : {};
      if (!validEmail(em)) { nfFehler(d.hintEmailFalsch || 'Bitte prüfe Deine E-Mail-Adresse.'); if (nfInput) nfInput.focus(); return; }
      var label = nfSend.textContent;
      nfSend.disabled = true;
      nfSend.textContent = ccT('up_sending', 'Wird gesendet…');
      leadMelden(em, 'upload_nofoto')
        .then(function () {
          if (nfForm) nfForm.classList.add('cc-up-hidden');
          if (nfOk) nfOk.classList.remove('cc-up-hidden');
        })
        .catch(function (err) {
          console.error('[cc-upload] Klaviyo-Subscribe fehlgeschlagen:', err);
          nfSend.disabled = false; nfSend.textContent = label;
          nfFehler('Das hat nicht geklappt. Bitte prüfe Deine Verbindung und versuche es noch einmal.');
        });
    });
  }

  // ---------- Foto ----------
  var fileInput = $('[data-cc-file]');
  var dropEmpty = $('[data-cc-drop-empty]');
  var dropFilled = $('[data-cc-drop-filled]');
  var previewImg = $('[data-cc-preview-img]');
  var dragover = $('[data-cc-dragover]');
  var drop = $('[data-cc-drop]');

  // Der gruene "E-Mail eingetragen"-Balken gehoert nur zum Weg Landing -> Upload.
  // Wer spaeter ueber den Mail-Link zurueckkommt, sah dieselbe Meldung ohne Kontext.
  // Die Landing setzt vor der Weiterleitung ein sessionStorage-Flag; nur dann zeigen.
  var mailnote = $('[data-cc-mailnote]');
  if (mailnote) {
    try {
      if (sessionStorage.getItem('cc_funnel_from_landing') === '1') {
        mailnote.classList.remove('cc-up-hidden');
        sessionStorage.removeItem('cc_funnel_from_landing');
      }
    } catch (e) {}
  }


  // Zeigt statt eines kaputten Bildes einen ehrlichen Hinweis. Betrifft vor allem HEIC/HEIF
  // vom iPhone: der Browser nimmt die Datei an (type = image/heic), kann sie aber nicht
  // darstellen — der Kunde sah nur ein leeres graues Feld (Alwin, 14.08.2026).
  function previewFehlt(file) {
    var frame = previewImg.parentNode;
    if (!frame) return;
    var typ = (file && file.type ? file.type.replace('image/', '').toUpperCase() : ccT('up_unknown', 'unbekannt'));
    previewImg.style.display = 'none';
    var alt = frame.querySelector('[data-cc-preview-fallback]');
    if (!alt) {
      alt = document.createElement('p');
      alt.className = 'cc-up-preview__fallback';
      alt.setAttribute('data-cc-preview-fallback', '');
      frame.appendChild(alt);
    }
    alt.textContent = ccT('up_format_unsupported', 'Dein Foto ([type]) ist angekommen – dieses Format kann der Browser hier nur nicht anzeigen. Du kannst ganz normal weitermachen.').replace('[type]', typ);
    ccTrack('cc_up_preview_unsupported', { funnel_step: 'upload_photo', mime: (file && file.type) || '' });
  }

  function setFile(file) {
    if (!file || !file.type || file.type.indexOf('image/') !== 0) return;
    if (state.previewUrl) { try { URL.revokeObjectURL(state.previewUrl); } catch (e) {} }
    state.file = file;
    state.previewUrl = URL.createObjectURL(file);

    previewImg.style.display = '';
    var fb = previewImg.parentNode && previewImg.parentNode.querySelector('[data-cc-preview-fallback]');
    if (fb) fb.remove();

    // Blob-URL zuerst; scheitert sie, ueber FileReader als Daten-URL versuchen.
    previewImg.onerror = function () {
      previewImg.onerror = function () { previewFehlt(file); };
      try {
        var fr = new FileReader();
        fr.onload = function () { previewImg.src = fr.result; };
        fr.onerror = function () { previewFehlt(file); };
        fr.readAsDataURL(file);
      } catch (e) { previewFehlt(file); }
    };
    previewImg.src = state.previewUrl;
    dropEmpty.classList.add('cc-up-hidden');
    dropFilled.classList.remove('cc-up-hidden');
    var howto = $('[data-cc-howto]');
    if (howto) howto.classList.add('cc-up-hidden');
    ccTrack('cc_up_photo_added', { funnel_step: 'upload_photo' });
    updateSubmit();
  }
  // ---------- iOS: nur EIN Button ----------
  // Safari oeffnet bei accept="image/*" immer ein Blatt mit Mediathek + Kamera + Dateien.
  // Ein zusaetzlicher Kamera-Button ist dort also doppelt gemoppelt. Auf Android bleiben
  // beide, weil dort ohne capture haeufig direkt die Galerie aufgeht und wer noch kein Foto
  // hat sonst feststeckt (60+-Nutzertest 15.08.2026). Der Kamera-Button darf auf iOS NICHT
  // der uebrig bleibende sein: mit capture kommt man dort an vorhandene Fotos gar nicht mehr.
  // iPadOS meldet sich als "MacIntel" -> Touchpoint-Pruefung noetig.
  var istIOS = /iPad|iPhone|iPod/.test(navigator.userAgent || '') ||
               ((navigator.platform === 'MacIntel' || /Macintosh/.test(navigator.userAgent || '')) && navigator.maxTouchPoints > 1);
  if (istIOS) {
    root.classList.add('cc-up-ios');
    var camBtn = $('[data-cc-open-camera]');
    if (camBtn) camBtn.style.display = 'none';
    var galBtn = $('[data-cc-open-file]');
    var galLabel = $('[data-cc-galerie-label]');
    var iosText = root.getAttribute('data-cc-ios-label');
    if (galLabel && iosText) galLabel.textContent = iosText;
    if (galBtn) { galBtn.classList.remove('cc-up-secondary'); galBtn.classList.add('cc-up-bigbtn'); }
  }

  var camInput = $('[data-cc-file-camera]');
  $$('[data-cc-open-file]').forEach(function (b) { b.addEventListener('click', function () { fileInput.click(); }); });
  // Kamera-Weg: eigenes Feld mit capture. Ohne das landet man auf Android oft direkt in
  // der Galerie — wer noch kein Foto gemacht hat, steckt dort fest (15.08.2026).
  $$('[data-cc-open-camera]').forEach(function (b) {
    b.addEventListener('click', function () { (camInput || fileInput).click(); });
  });
  fileInput.addEventListener('change', function (e) { if (e.target.files && e.target.files[0]) setFile(e.target.files[0]); e.target.value = ''; });
  if (camInput) camInput.addEventListener('change', function (e) { if (e.target.files && e.target.files[0]) setFile(e.target.files[0]); e.target.value = ''; });
  var _el1 = $('[data-cc-remove-photo]'); if (_el1) _el1.addEventListener('click', function () {
    state.file = null;
    if (state.previewUrl) { try { URL.revokeObjectURL(state.previewUrl); } catch (e) {} }
    dropFilled.classList.add('cc-up-hidden');
    dropEmpty.classList.remove('cc-up-hidden');
    var howto2 = $('[data-cc-howto]');
    if (howto2) howto2.classList.remove('cc-up-hidden');
    updateSubmit();
  });
  ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); dragover.classList.remove('cc-up-hidden'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); dragover.classList.add('cc-up-hidden'); }); });
  drop.addEventListener('drop', function (e) { e.preventDefault(); if (e.dataTransfer.files && e.dataTransfer.files[0]) setFile(e.dataTransfer.files[0]); });

  // ---------- Motiv-Picker ----------
  var drawer = $('[data-cc-drawer]');
  var motifPlus = $('[data-cc-motif-plus]');
  var motifSelected = $('[data-cc-motif-selected]');
  var selectedName = $('[data-cc-selected-name]');
  var selectedImg = $('[data-cc-selected-img]');
  function openPicker() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closePicker() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-cc-open-picker]').forEach(function (b) { b.addEventListener('click', openPicker); });
  $$('[data-cc-close-picker]').forEach(function (b) { b.addEventListener('click', closePicker); });

  // ---------- Schnellansicht (Quickview) ----------
  var quickModal = $('[data-cc-quick-modal]');
  var quickImg = $('[data-cc-quick-img]');
  var quickTitle = $('[data-cc-quick-title]');
  var quickSelectBtn = $('[data-cc-quick-select]');
  var quickCurrentTile = null;

  // Galerie in der Schnellansicht: dieselben Fotos wie auf der Muster-Produktseite,
  // geliefert über data-cc-quick-images (Varianten-Metafield custom.muster_set_images).
  // Punkte werden hier erzeugt, damit die Section kein zusätzliches Markup braucht.
  var quickDots = null;
  var quickShots = [];
  var quickIndex = 0;

  function quickShow(i) {
    if (!quickShots.length || !quickImg) return;
    quickIndex = (i + quickShots.length) % quickShots.length;
    quickImg.src = quickShots[quickIndex];
    if (quickDots) {
      Array.prototype.forEach.call(quickDots.children, function (d, n) {
        d.classList.toggle('is-active', n === quickIndex);
        d.setAttribute('aria-current', n === quickIndex ? 'true' : 'false');
      });
    }
  }

  function quickBuildDots() {
    if (!quickImg) return;
    if (!quickDots) {
      quickDots = document.createElement('div');
      quickDots.className = 'cc-up-quickdots';
      quickImg.parentNode.insertBefore(quickDots, quickImg.nextSibling);
      quickDots.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (b) quickShow(parseInt(b.getAttribute('data-i'), 10));
      });
      // Tippen/Klicken aufs Bild blättert weiter — auf dem Handy die naheliegendste Geste.
      quickImg.addEventListener('click', function () { if (quickShots.length > 1) quickShow(quickIndex + 1); });
    }
    quickDots.innerHTML = '';
    if (quickShots.length < 2) { quickDots.hidden = true; return; }
    quickDots.hidden = false;
    quickShots.forEach(function (_, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-i', n);
      b.setAttribute('aria-label', ccT('img_of', 'Bild [n] von [total]').replace('[n]', n + 1).replace('[total]', quickShots.length));
      quickDots.appendChild(b);
    });
  }

  function openQuick(tile) {
    quickCurrentTile = tile;
    var trigger = tile.querySelector('[data-cc-quick]');
    var url = trigger.getAttribute('data-cc-quick');
    var name = tile.getAttribute('data-cc-motif');

    quickShots = [];
    try {
      var raw = trigger.getAttribute('data-cc-quick-images');
      if (raw) quickShots = JSON.parse(raw).filter(Boolean);
    } catch (err) { quickShots = []; }
    // Ohne gepflegte Metafield-Bilder bleibt es beim Varianten-Bild — nie eine leere Ansicht.
    if (!quickShots.length && url) quickShots = [url];

    if (quickImg) quickImg.alt = ccT('motif_alt', 'Motiv [name]').replace('[name]', name);
    quickBuildDots();
    quickShow(0);

    if (quickTitle) quickTitle.textContent = name;
    if (quickModal) { quickModal.classList.add('is-open'); }
    ccTrack('cc_up_quickview', { funnel_step: 'upload_motif', motiv: name });
  }
  function closeQuick() { if (quickModal) quickModal.classList.remove('is-open'); }
  if (quickModal) {
    quickModal.addEventListener('click', function (e) { if (e.target === quickModal) closeQuick(); });
    var qc = $('[data-cc-close-quick]'); if (qc) qc.addEventListener('click', closeQuick);
    if (quickSelectBtn) quickSelectBtn.addEventListener('click', function () {
      closeQuick();
      if (quickCurrentTile) quickCurrentTile.click();
    });
  }

  // Der Vorschau-Server kennt nur die deutschen Motivnamen. Ausserhalb von 'de' wird der
  // angezeigte Name ueber die Varianten-ID (window.CC_MOTIF_VARIANTS) auf den deutschen Namen von danario.de abgebildet.
  function ccMotifForServer(name) {
    var loc = (window.Shopify && window.Shopify.locale) || 'de';
    if (!name || loc === 'de') return Promise.resolve(name);
    var id = (window.CC_MOTIF_VARIANTS || {})[name];
    if (!id) return Promise.resolve(name);
    return fetch('https://danario.de/products/muster.js', { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var hit = (p.variants || []).filter(function (v) { return String(v.id) === String(id); })[0];
        return hit && hit.option2 ? hit.option2 : name;
      })
      .catch(function () { return name; });
  }

  var tiles = $$('[data-cc-motif]');
  tiles.forEach(function (tile) {
    tile.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-cc-quick]')) { e.preventDefault(); openQuick(tile); return; }
      var motif = tile.getAttribute('data-cc-motif');
      var mimg = tile.getAttribute('data-cc-motif-img');
      state.motif = motif; state.motifImg = mimg;
      ccTrack('cc_up_motif_selected', { funnel_step: 'upload_motif', motiv: motif });
      tiles.forEach(function (t) { t.classList.remove('is-selected'); });
      tile.classList.add('is-selected');
      selectedName.textContent = motif;
      if (selectedImg && mimg) { selectedImg.src = mimg; selectedImg.alt = ccT('motif_alt', 'Motiv [name]').replace('[name]', motif); }
      motifPlus.classList.add('cc-up-hidden');
      motifSelected.classList.remove('cc-up-hidden');
      closePicker();
      updateSubmit();
    });
  });
  var search = $('[data-cc-search]');
  if (search) {
    search.addEventListener('input', function () {
      var q = search.value.toLowerCase().trim();
      tiles.forEach(function (t) {
        var name = (t.getAttribute('data-cc-motif') || '').toLowerCase();
        t.style.display = (!q || name.indexOf(q) >= 0) ? '' : 'none';
      });
    });
  }

  // ---------- E-Mail prefill (URL-Param -> sessionStorage-Fallback); Karte ausblenden wenn bekannt ----------
  var emailInput = $('[data-cc-email]');
  var emailCard = $('[data-cc-email-card]');
  var emailBekannt = false;
  var emailGezeigt = false;
  try {
    var qs = new URLSearchParams(location.search);
    var pe = qs.get('email');
    if (pe) {
      // E-Mail sofort aus der sichtbaren URL nehmen: sie landet sonst in Browser-Verlauf,
      // Lesezeichen, Referrern und Analytics — eine Adresse hat in einer URL nichts verloren.
      // Der Wert lebt danach nur noch im sessionStorage dieses Tabs.
      try {
        qs.delete('email');
        var rest = qs.toString();
        history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
      } catch (e) {}
    }
    if (!pe) { try { pe = sessionStorage.getItem('cc_funnel_email') || ''; } catch (e) {} }
    if (pe && emailInput) {
      emailInput.value = pe;
      try { sessionStorage.setItem('cc_funnel_email', pe); } catch (e) {}
      if (emailCard && /.+@.+\..+/.test(pe)) { emailCard.classList.add('cc-up-hidden'); emailBekannt = true; }
    }
  } catch (e) {}
  // Variante B: Karte 3 (E-Mail) erst zeigen, wenn Foto und Motiv da sind (updateSubmit).
  function emailPflicht() { return !!(AB.modusB && emailCard && emailInput && !emailBekannt); }
  var gemeldet = {};   // Adressen, die auf dieser Seite schon an Klaviyo/Meta gingen (kein doppelter Lead)
  var emailErr = $('[data-cc-email-err]');
  function emailFehler(msg) {
    if (!emailErr) return;
    emailErr.textContent = msg || '';
    emailErr.classList.toggle('cc-up-hidden', !msg);
  }
  if (emailInput) emailInput.addEventListener('input', function () { emailFehler(''); });
  if (emailPflicht()) {
    emailCard.classList.add('cc-up-hidden');
    emailInput.setAttribute('placeholder', ccT('up_email_placeholder', 'Deine E-Mail-Adresse'));
    emailInput.setAttribute('aria-labelledby', 'cc-up-email-b-title');
    emailInput.addEventListener('input', function () { updateSubmit(); });
  }

  // ---------- Help-Modal ----------
  // Das Hilfe-Fenster ist optional: Der Hilfe-Button wurde am 15.08.2026 aus der Seite
  // genommen (60+-Nutzertest, zu viele Klickpunkte). Ohne diese Pruefung warf die
  // Bindung hier "null.addEventListener" — und weil das die gesamte Initialisierung
  // abbrach, blieb der Submit-Button dauerhaft ausgegraut. Nie ungeprueft binden.
  var helpModal = $('[data-cc-help-modal]');
  var helpOpen = $('[data-cc-open-help]');
  if (helpModal && helpOpen) {
    helpOpen.addEventListener('click', function () { helpModal.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    $$('[data-cc-close-help]').forEach(function (b) { b.addEventListener('click', function () { helpModal.classList.remove('is-open'); document.body.style.overflow = ''; }); });
    helpModal.addEventListener('click', function (e) { if (e.target === helpModal) { helpModal.classList.remove('is-open'); document.body.style.overflow = ''; } });
  }

  // ---------- Submit ----------
  var submitBtn = $('[data-cc-submit]');
  var submitHint = $('[data-cc-submithint]');
  var uploadStatus = $('[data-cc-upload-status]');
  function updateSubmit() {
    var bildUndMotiv = !!(state.file && state.motif);
    var pflicht = emailPflicht();
    if (pflicht && bildUndMotiv && emailCard.classList.contains('cc-up-hidden')) {
      // Variante B: jetzt erst nach der E-Mail fragen. Einmal hinscrollen, nicht fokussieren
      // (die Tastatur sprang sonst direkt nach dem Schliessen des Motiv-Fensters auf).
      emailCard.classList.remove('cc-up-hidden');
      if (!emailGezeigt) {
        emailGezeigt = true;
        ccTrack('cc_up_email_shown', { funnel_step: 'upload_email', cc_ab: AB.tag });
        setTimeout(function () { try { emailCard.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }, 200);
      }
    }
    var emailOk = !pflicht || validEmail(emailInput.value);
    var ready = bildUndMotiv && emailOk;
    submitBtn.disabled = !ready;
    if (!submitHint) return;
    submitHint.style.display = ready ? 'none' : '';
    if (ready) return;
    // Konkret sagen, was fehlt: wer mit dem Motiv anfaengt, sieht sonst nur den
    // Sammelsatz und sucht den Fehler bei sich (Alwin 24.08.2026).
    var d = submitHint.dataset;
    if (!state.file && !state.motif) submitHint.textContent = d.hintBeides || submitHint.textContent;
    else if (!state.file) submitHint.textContent = d.hintFoto || submitHint.textContent;
    else if (!state.motif) submitHint.textContent = d.hintMotiv || submitHint.textContent;
    else submitHint.textContent = (emailInput.value.trim() ? d.hintEmailFalsch : d.hintEmail) || submitHint.textContent;
  }
  updateSubmit();

  // Motiv von der Produktseite vorbelegen: Der Button dort verlinkt /pages/kuechenvorschau?motiv=<Name>,
  // die Landing reicht es als ?motiv= durch. Muss NACH submitBtn stehen, weil der Klick updateSubmit ruft.
  try {
    var vorMotiv = (new URLSearchParams(location.search).get('motiv') || '').trim().toLowerCase();
    if (vorMotiv) {
      tiles.forEach(function (t) {
        if (!state.motif && (t.getAttribute('data-cc-motif') || '').trim().toLowerCase() === vorMotiv) t.click();
      });
    }
  } catch (e) {}

  // Foto clientseitig verkleinern (JPEG) -> Upload-Zeit sinkt bei schlechtem Netz massiv.
  // 2000px (nicht mehr 1200): mehr Detail-Substanz fuer die AI-Generierung; muss zu
  // KV_MAX_PHOTO im Endpoint passen.
  function shrinkPhoto(file) {
    return new Promise(function (resolve) {
      try {
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function () {
          try {
            var MAX = 2000;
            var w = img.naturalWidth, h = img.naturalHeight;
            if (Math.max(w, h) <= MAX) { URL.revokeObjectURL(url); return resolve(file); }
            var f = MAX / Math.max(w, h);
            var c = document.createElement('canvas');
            c.width = Math.round(w * f); c.height = Math.round(h * f);
            c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
            c.toBlob(function (blob) {
              URL.revokeObjectURL(url);
              resolve(blob ? new File([blob], 'kuechenfoto.jpg', { type: 'image/jpeg' }) : file);
            }, 'image/jpeg', 0.72);   // 0.85 ergab ~2,4 MB und damit mehrere Sekunden Upload auf Mobilfunk; 0.72 spart rund 30 % ohne sichtbaren Verlust fuer die Generierung (15.08.2026)
          } catch (err) { resolve(file); }
        };
        img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
        img.src = url;
      } catch (err) { resolve(file); }
    });
  }

  submitBtn.addEventListener('click', function () {
    if (!state.file || !state.motif) return;
    var email = emailInput ? emailInput.value.trim() : '';
    var neueAdresse = emailPflicht();
    if (neueAdresse && !validEmail(email)) { updateSubmit(); return; }
    ccTrack('cc_up_submit', { funnel_step: 'upload_submit', motiv: state.motif });
    // Variante B: Adresse zuerst an Klaviyo (keepalive), erst danach der Upload. Der Flow
    // startet mit dem Listeneintrag und prueft 15 Minuten spaeter, ob die Vorschau da ist.
    emailFehler('');
    if (neueAdresse && !gemeldet[email.toLowerCase()]) {
      gemeldet[email.toLowerCase()] = true;
      leadMelden(email, 'upload_email').catch(function (err) { console.error('[cc-upload] Klaviyo-Subscribe fehlgeschlagen:', err); });
    }
    abMelden('upload');
    var label = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = ccT('up_sending', 'Wird gesendet…');

    function goToDanke(jobId) {
      var q = 'motiv=' + encodeURIComponent(state.motif);
      if (jobId) q += '&job=' + encodeURIComponent(jobId);
      window.location.href = dankeUrl + (dankeUrl.indexOf('?') >= 0 ? '&' : '?') + q;
    }

    if (!uploadEndpoint) {
      console.warn('[cc-upload] Kein Upload-Endpoint gesetzt — Demo-Weiterleitung ohne echten Foto-Upload.');
      goToDanke();
      return;
    }
    if (uploadStatus) { uploadStatus.classList.remove('cc-up-hidden', 'cc-up-status--error'); uploadStatus.textContent = 'Foto wird hochgeladen…'; }
    Promise.all([shrinkPhoto(state.file), ccMotifForServer(state.motif)]).then(function (pm) {
    var photoFile = pm[0];
    var fd = new FormData();
    fd.append('photo', photoFile, photoFile.name || 'kuechenfoto.jpg');
    fd.append('email', email);
    fd.append('motiv', pm[1]);
    if (AB.tag) fd.append('ab', AB.tag);
    return fetch(uploadEndpoint, { method: 'POST', body: fd })
      .then(function (r) {
        if (r.ok) return r.json().catch(function () { return {}; });
        // Der Endpoint begruendet Ablehnungen im Feld "detail" (Limit erreicht, kein Kuechenfoto
        // erkannt, …). Diese Begruendung MUSS beim Kunden ankommen: Am 15.08.2026 lief ein
        // Test in ein Limit, der Button sprang wortlos zurueck und die Seite wirkte kaputt.
        return r.json().catch(function () { return {}; }).then(function (j) {
          var e = new Error('upload-http-' + r.status);
          e.serverText = j && (j.detail || j.message);
          e.status = r.status;
          throw e;
        });
      })
      .then(function (data) { goToDanke(data && data.job_id); }); })
      .catch(function (err) {
        console.error('[cc-upload] Upload-Fehler:', err);
        submitBtn.disabled = false; submitBtn.textContent = label;
        // Kontingent der E-Mail verbraucht: Die Meldung gehoert unter das E-Mail-Feld, nicht
        // unter das Foto (Alwin 29.09.2026). Nur wenn das Feld sichtbar ist, sonst wie bisher.
        var emailSichtbar = emailCard && emailErr && !emailCard.classList.contains('cc-up-hidden');
        if (emailSichtbar && err && err.status === 429 && /diese E-Mail/i.test(err.serverText || '')) {
          if (uploadStatus) uploadStatus.classList.add('cc-up-hidden');
          emailFehler(err.serverText);
          try { emailErr.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
          return;
        }
        if (uploadStatus) {
          uploadStatus.classList.remove('cc-up-hidden');
          uploadStatus.classList.add('cc-up-status--error');
          uploadStatus.textContent = (err && err.serverText)
            ? err.serverText
            : ccT('up_error', 'Der Upload hat nicht geklappt. Bitte prüfe Deine Verbindung und versuche es noch einmal.');
          try { uploadStatus.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        }
      });
  });
})();
